import { useTheme } from "@mui/material";
import * as React from "react";
import { useGetUIThemeMode } from "shared";
const Logo = (props) => {
  const currentThemeMode = useGetUIThemeMode();
  const theme = useTheme();
  return(
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 511.992 511.992"
    style={{
      enableBackground: "new 0 0 511.992 511.992",
    }}
    xmlSpace="preserve"
    height={42}
    width={42}
    {...props}
    color="secondary.dark"
    filter={`drop-shadow(1px 1px 2px ${currentThemeMode === "dark" ? theme.palette.secondary.dark : theme.palette.secondary.light})`}
  >
    <rect x={240} y={358.988} width={32} height={77.528} />
    <polygon points="155.904,456.428 166.568,424.428 345.432,424.428 356.096,456.428 " />
    <path
      style={{
        fill: "#FFFFFF",
      }}
      d="M37.296,362.62C21.144,362.62,8,349.476,8,333.316V92.868c0-16.16,13.144-29.296,29.296-29.296 h437.408c16.16,0,29.296,13.144,29.296,29.296v240.456c0,16.16-13.144,29.296-29.296,29.296H37.296z"
    />
    <path d="M474.704,71.564c11.744,0,21.296,9.552,21.296,21.296v240.456c0,11.744-9.552,21.296-21.296,21.296H37.296 C25.552,354.612,16,345.06,16,333.316V92.86c0-11.744,9.552-21.296,21.296-21.296H474.704 M474.704,55.564H37.296 C16.784,55.564,0,72.348,0,92.86v240.456c0,20.512,16.784,37.296,37.296,37.296h437.4c20.512,0,37.296-16.784,37.296-37.296V92.86 C512,72.348,495.216,55.564,474.704,55.564L474.704,55.564z" />
    <path
      style={{
        fill: "#FF583E",
      }}
      d="M345.68,324.26H166.32c-17.304,0-31.464-14.16-31.464-31.464v-111.72 c0-17.304,14.16-31.464,31.464-31.464h179.36c17.304,0,31.464,14.16,31.464,31.464v111.72 C377.144,310.1,362.984,324.26,345.68,324.26z"
    />
    <path d="M325.16,185.14h-15.144v-55.368c0-9.76-7.936-17.704-17.696-17.704h-72.64c-9.76,0-17.696,7.944-17.696,17.704v55.368 H186.84v-55.368c0-18.104,14.728-32.84,32.84-32.84h72.648c18.104,0,32.84,14.736,32.84,32.84v55.368H325.16z" />
    <g>
      <path
        style={{
          fill: "#FFFFFF",
        }}
        d="M185.176,283.068c3.272,0.608,8.056,0.736,12.552-0.608c4.832-1.456,6.768-4.24,5.864-7.272 c-0.872-2.896-3.584-3.888-9.784-4.208c-8.544-0.368-14.872-3.128-16.92-9.888c-2.384-7.936,2.416-16.024,13.392-19.32 c5.248-1.584,9.44-1.632,12.584-1.232l0.208,9.2c-2.144-0.336-5.84-0.648-10.408,0.728c-4.552,1.376-6.136,4.104-5.408,6.528 c0.888,2.96,3.904,3.48,10.608,3.944c9.128,0.56,14.28,3.68,16.248,10.248c2.352,7.792-1.656,16.216-14.424,20.072 c-5.312,1.592-10.976,1.8-14.032,1.136L185.176,283.068z"
      />
      <path
        style={{
          fill: "#FFFFFF",
        }}
        d="M209.976,233.964l10.496-3.168l5.8,19.272l0.128-0.04c0.68-1.792,1.72-3.304,3.112-4.712 c1.272-1.28,3.128-2.368,5.064-2.944c6.688-2.024,13.184,1.064,16.248,11.208l5.944,19.752l-10.496,3.168l-5.592-18.576 c-1.336-4.416-3.768-7-7.696-5.824c-2.768,0.832-3.944,3.144-4.144,5.24c-0.064,0.784,0.136,1.712,0.368,2.456l6.032,20.024 l-10.496,3.168L209.976,233.964z"
      />
      <path
        style={{
          fill: "#FFFFFF",
        }}
        d="M293.336,243.508c3.72,12.352-3.344,20.648-12.392,23.376c-9.864,2.968-19.416-1.24-22.696-12.136 c-3.28-10.92,1.8-20.056,12.632-23.312C281.232,228.308,290.272,233.348,293.336,243.508z M268.992,251.204 c1.752,5.8,5.48,9.424,9.968,8.072c4.064-1.232,5.472-6.104,3.648-12.176c-1.52-5.032-5-9.56-9.76-8.128 C267.8,240.492,267.488,246.236,268.992,251.204z"
      />
      <path
        style={{
          fill: "#FFFFFF",
        }}
        d="M298.24,236.372c-1.336-4.424-2.616-8.168-3.688-11.24l9.112-2.752l1.896,4.552l0.136-0.04 c1.408-4.344,4.72-7.376,9.616-8.84c7.392-2.232,15.944,2.2,19.2,12.968c3.696,12.288-2.352,20.44-9.888,22.712 c-4.072,1.216-7.736,0.52-9.936-1.232l-0.128,0.04l5.056,16.784l-10.496,3.168L298.24,236.372z M311.128,241.14 c0.248,0.824,0.552,1.576,0.872,2.144c1.544,2.624,4.608,4.032,7.648,3.128c4.552-1.376,6.104-5.976,4.376-11.712 c-1.624-5.384-5.272-8.728-9.96-7.312c-2.968,0.888-4.928,3.888-4.688,7.2c0.032,0.592,0.168,1.304,0.368,1.928L311.128,241.14z"
      />
    </g>
  </svg>
)};
export default Logo;